import { wait } from '../utils';
import { SendTransactionError, } from '@solana/web3.js';
export async function resendTransactionWithInterval({ transaction, resendInterval, connection, abortSignal, sendOptions, }) {
    while (!abortSignal.aborted) {
        await wait(resendInterval * 1000);
        try {
            await connection.sendTransaction(transaction, sendOptions);
        }
        catch (error) {
            throw new SendTransactionError('ResendTransactionError');
        }
    }
}
export async function sendTransactionWithResendInterval({ transaction, connection, sendOptions, resendOptions, }) {
    const signature = await connection.sendTransaction(transaction, sendOptions);
    //? Prevent using resendTransactionWithInterval if resendOptions is undefined
    if (resendOptions) {
        resendTransactionWithInterval({
            transaction,
            connection,
            abortSignal: resendOptions.abortSignal,
            sendOptions,
            resendInterval: resendOptions.interval,
        });
    }
    return signature;
}
